import React, {useState, useRef, useEffect} from 'react';
import Countdown, {zeroPad} from 'react-countdown';
import Button from 'design-system/src/Components/Button/Button';
import {useTranslation} from 'gatsby-plugin-react-i18next';

interface CountdownButtonProps {
  date: Date | string | number;
  onRefresh?: () => void | Promise<void>;
  cooldown?: boolean;
  cooldownLeft?: number;
}

const CountdownButton: React.FC<CountdownButtonProps> = ({
  date,
  onRefresh,
  cooldown,
  cooldownLeft,
}) => {
  const {t} = useTranslation('ui');
  const refresh = t('cooldown.refresh');
  const nextRefresh = t('cooldown.nextRefresh');

  const handleRefresh = () => onRefresh && Promise.resolve(onRefresh());

  const renderer = ({hours, minutes, seconds, completed}: any) => {
    if (completed) {
      return (
        <Button
          variant="outlined"
          onPress={handleRefresh}
          style={{minWidth: 160}}
          title={cooldown ? `${nextRefresh}: ${cooldownLeft}s` : refresh}
          disabled={cooldown}>
          {cooldown ? `Next refresh: ${cooldownLeft}s` : 'Refresh'}
          {cooldownLeft}
        </Button>
      );
    } else {
      return (
        <Button
          variant="outlined"
          disabled
          title={`${zeroPad(hours)}:${zeroPad(minutes)}:${zeroPad(seconds)}`}>
          {zeroPad(hours)}:{zeroPad(minutes)}:{zeroPad(seconds)}
        </Button>
      );
    }
  };

  return <Countdown date={date} renderer={renderer} />;
};

export default CountdownButton;
